import { CDN_IMAGES_URL } from '@marketplace-web/shared/assets'

export const IMAGE_BASE_URL = `${CDN_IMAGES_URL}/landing/vpi`
export const DOCUMENTATION_URL = 'https://pro-docs.svc.vinted.com'
